var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.canEdit
    ? _c(
        "v-edit-dialog",
        {
          attrs: {
            "return-value": _vm.workingValue,
            large: "",
            persistent: ""
          },
          on: {
            "update:returnValue": function($event) {
              _vm.workingValue = $event
            },
            "update:return-value": function($event) {
              _vm.workingValue = $event
            },
            save: _vm.saveChange
          },
          scopedSlots: _vm._u(
            [
              {
                key: "input",
                fn: function() {
                  return [
                    _c("div", { staticClass: "mt-4 text-h6" }, [
                      _vm._v("\n      " + _vm._s(_vm.title) + "\n    ")
                    ]),
                    _vm._v(" "),
                    _vm.isDropdown
                      ? _c("v-autocomplete", {
                          attrs: { items: _vm.items, "single-line": "" },
                          model: {
                            value: _vm.workingValue,
                            callback: function($$v) {
                              _vm.workingValue = $$v
                            },
                            expression: "workingValue"
                          }
                        })
                      : _vm.isPrice
                      ? _c("v-text-field", {
                          attrs: {
                            clearable: _vm.clearable,
                            type: "number",
                            prefix: "$",
                            step: "0.01",
                            "single-line": "",
                            autofocus: ""
                          },
                          model: {
                            value: _vm.workingValue,
                            callback: function($$v) {
                              _vm.workingValue = $$v
                            },
                            expression: "workingValue"
                          }
                        })
                      : _vm.isDate
                      ? _c(
                          "v-menu",
                          {
                            ref: "menu",
                            attrs: {
                              "close-on-content-click": false,
                              transition: "scale-transition",
                              left: "",
                              "min-width": "auto"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        "v-text-field",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              attrs: {
                                                placeholder:
                                                  "Click to select Date",
                                                clearable: _vm.clearable,
                                                readonly: ""
                                              },
                                              model: {
                                                value: _vm.workingValue,
                                                callback: function($$v) {
                                                  _vm.workingValue = $$v
                                                },
                                                expression: "workingValue"
                                              }
                                            },
                                            "v-text-field",
                                            attrs,
                                            false
                                          ),
                                          on
                                        )
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2442833905
                            ),
                            model: {
                              value: _vm.menu,
                              callback: function($$v) {
                                _vm.menu = $$v
                              },
                              expression: "menu"
                            }
                          },
                          [
                            _vm._v(" "),
                            _c(
                              "v-date-picker",
                              {
                                attrs: { "no-title": "", scrollable: "" },
                                model: {
                                  value: _vm.parsedDate,
                                  callback: function($$v) {
                                    _vm.parsedDate = $$v
                                  },
                                  expression: "parsedDate"
                                }
                              },
                              [
                                _c("v-spacer"),
                                _vm._v(" "),
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { text: "", color: "primary" },
                                    on: {
                                      click: function($event) {
                                        _vm.menu = false
                                      }
                                    }
                                  },
                                  [_vm._v("\n          Cancel\n        ")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { text: "", color: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.$refs.menu.save(
                                          _vm.workingValue
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("\n          OK\n        ")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _c("v-text-field", {
                          attrs: {
                            clearable: _vm.clearable,
                            label: "Edit",
                            "single-line": "",
                            autofocus: ""
                          },
                          model: {
                            value: _vm.workingValue,
                            callback: function($$v) {
                              _vm.workingValue = $$v
                            },
                            expression: "workingValue"
                          }
                        })
                  ]
                },
                proxy: true
              }
            ],
            null,
            false,
            3629841894
          )
        },
        [
          _vm._v(
            "\n  " +
              _vm._s(
                _vm.isPrice && _vm.workingValue
                  ? "$" + _vm.workingValue
                  : _vm.workingValue
              ) +
              "\n  "
          )
        ]
      )
    : _c("div", [
        _vm._v(
          "\n  " +
            _vm._s(_vm.isPrice && _vm.value ? "$" + _vm.value : _vm.value) +
            "\n"
        )
      ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-db5ecb24", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db5ecb24","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/items/edit_dialog.vue
// module id = null
// module chunks = 